import { Signal, Type, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

export type ModalTemplateType = 'DEFAULT' | 'NO_CLOSE' | 'LARGE' | 'CLEAR' | 'SMALL';

export interface ModalOptions {
  template?: ModalTemplateType;
  disableOverlayClosing?: boolean;
  closeAfterRouteChange?: boolean;
  data?: any;
}

export abstract class Modal {
  instance: ModalRefInterface;
  options: ModalOptions;

  close(output?: any): void {
    this.instance.close(output);
  }

  dismiss(output?: any): void {
    this.instance.dismiss(output);
  }
}

export interface ModalComponentInterface {
  modalOverlay: Signal<ViewContainerRef>;
  modalContainer: Signal<ViewContainerRef>;
  template: any;
  createModal(component: Type<any>, template: any): any;
}

export interface ModalRefInterface {
  options: any;
  close(output?: any): void;
  dismiss(output: any): void;
  onResult(): Observable<any>;
}
